import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnAL: CultureInfo = {
  name: 'en-AL',
  displayName: 'English (Albania)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-AL',
  parent: CultureInfoEn
};
